__turbopack_context__.v({
  "body": "WorldSleepSection-module___f8b2a__body",
  "copy": "WorldSleepSection-module___f8b2a__copy",
  "copyColumn": "WorldSleepSection-module___f8b2a__copyColumn",
  "findStore": "WorldSleepSection-module___f8b2a__findStore",
  "globeBleed": "WorldSleepSection-module___f8b2a__globeBleed",
  "globeFade": "WorldSleepSection-module___f8b2a__globeFade",
  "globeMedia": "WorldSleepSection-module___f8b2a__globeMedia",
  "globeMediaReady": "WorldSleepSection-module___f8b2a__globeMediaReady",
  "globeSnapshot": "WorldSleepSection-module___f8b2a__globeSnapshot",
  "globeSnapshotFaded": "WorldSleepSection-module___f8b2a__globeSnapshotFaded",
  "globeStage": "WorldSleepSection-module___f8b2a__globeStage",
  "inner": "WorldSleepSection-module___f8b2a__inner",
  "outer": "WorldSleepSection-module___f8b2a__outer",
  "stat": "WorldSleepSection-module___f8b2a__stat",
  "statLabel": "WorldSleepSection-module___f8b2a__statLabel",
  "statValue": "WorldSleepSection-module___f8b2a__statValue",
  "stats": "WorldSleepSection-module___f8b2a__stats",
  "title": "WorldSleepSection-module___f8b2a__title",
});
